'use strict';

export default class ActivateWebaccessController {
  errors = {
    forgot: undefined
  };
  submitted = false;

  /*@ngInject*/
  constructor($state, $stateParams, WebAccessService, IntegrationService, SettingsService, dialogs) {
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.WebAccessService = WebAccessService;
    this.IntegrationService = IntegrationService;
    this.dialogs = dialogs;

    SettingsService.getByName({name: 'client'}, settings => {

      this.useSuite = settings.data.useSuite;

      let fnSuccess = wa => {
        this.wa = wa;
        this.wa.token = $stateParams.token;
        this.wa.password = '';
        this.wa.confirmPassword = '';
      };

      if (this.useSuite) {
        IntegrationService.suiteGetWebAccessEmail({webaccessId: $stateParams.webaccessId, token: $stateParams.token}, fnSuccess);
      } else {
        WebAccessService.getWebAccessEmail({webaccessId: $stateParams.webaccessId, token: $stateParams.token}, fnSuccess);
      }
    });
  }

  submit(form) {
    this.submitted = true;

    if(form.$valid) {

      let payload =  {
        email: this.wa.email,
        password: this.wa.password,
        token: this.wa.token
      };

      let fnDone = user => {
        let dlg = this.dialogs.notify("Account Activated", "You have successfully activated your account.<br/>You can now login with your email and password.");
        dlg.result.then(() => {
          this.$state.go("main");
        }, () => {
          this.$state.go("main");
        });
      };

      let fnErr = err => {
        alert(err.message);
      };

      if (this.useSuite) {
        this.IntegrationService.suiteActivatedWebAccess({webaccessId: this.wa._id}, payload, fnDone, fnErr);
      } else {
        this.WebAccessService.activate({webaccessId: this.wa._id},payload, fnDone, fnErr);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/activate-webaccess/activate-webaccess.controller.js